import * as actionTypes from './action-types';
import { API_REQUEST } from '../../../../store/sagas/api';
import { getCoursesProfileInformation } from '../../../../backend-api';

export const loadCoursesProfileInformation = () => ({
  type: API_REQUEST,
  types: [
    actionTypes.LOAD_COURSES_PROFILE,
    actionTypes.LOAD_COURSES_PROFILE_SUCCESS,
    actionTypes.LOAD_COURSES_PROFILE_FAIL,
  ],
  call: () => getCoursesProfileInformation(),
});
